import { jsx as r } from "react/jsx-runtime";
import { isBefore as s, addMonths as f, isAfter as l, endOfMonth as c, subMonths as m } from "date-fns";
import { CircleButton as p } from "./index.es17.js";
import { UtilityPaginationIcon as h } from "./index.es455.js";
const y = ({
  incrementOrDecrementMonth: d,
  isIncrement: t,
  value: i,
  maxDate: e,
  minDate: n
}) => {
  let o;
  const a = /* @__PURE__ */ new Date(`${i.year}-${i.month}-01`);
  return t ? o = !e || s(f(a, 1), e) : o = !n || l(c(m(a, 1)), n), /* @__PURE__ */ r("span", { style: t ? { marginLeft: "8px" } : { marginRight: "8px" }, children: /* @__PURE__ */ r(
    p,
    {
      disabled: !o,
      icon: /* @__PURE__ */ r(
        h,
        {
          direction: t ? "forward" : "backwards",
          color: o ? "default-gray" : "disabled",
          size: 18
        }
      ),
      onClick: () => d(t),
      variant: "default"
    }
  ) });
};
export {
  y as IncrementDecrementMonthButton
};
//# sourceMappingURL=index.es5864.js.map
